import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";

import Pagination from "../../../components/Pagination";

const PreCoolingListview = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);

    const id = data && data.preCoolingId;
    if (id) {
      getPreCooling(
        {
          url: `/api/pre-Cooling/?orgId=${localStorage.getItem(
            "orgId"
          )}&preCoolingId=${id}`,
        },
        (res) => {
          if (res) {
            //console.log(res);
            setSelectedData(res);
          }
        }
      );
    }

    setIsModalOpen(true);
  };
  const { addForm, update, sId } = props;

  const [data, setData] = useState([]);
  const [pcData, setPcData] = useState([]);
  const [allData, setAllData] = useState([]);

  const { sendRequest: getPreCooling } = useHttp();

  useEffect(() => {
    getPreCooling(
      {
        url: "/api/pre-Cooling/",
      },
      (res) => {
        if (res) {
          const sortedData = res.sort(
            (a, b) => b.preCoolingId - a.preCoolingId
          );
          setData(sortedData);
          // //console.log(res);
          setPcData(res[0]);
          setAllData(res);
        }
      }
    );
  }, [getPreCooling]);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata =
      allData &&
      allData.filter((item) => item.preCoolingNo.includes(filetrtext));

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Pre Cooling</label>
          </div>

          <div className="col-6 text-right">
          {canAdd === "block" && (
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                sId(serviceId);
                props.update(false);
              }}
            >
              Add PreCooling
            </button>)}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Doc No</th>
                          <th>Assigned Supervisor</th>
                          <th>Start Time</th>
                          <th>End Time</th>
                          <th>Initial Temp(°C)</th>
                          <th>Final Temp(°C)</th>
                          <th>Pre- Cooling Method</th>
                          {canEdit === "block" && <th>Edit</th>}
                          {canDelete === "block" && <th>Delete</th>}
                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.preCoolingDate}</td>
                                <td>{itm.preCoolingNo}</td>
                                <td>{itm.employeeName}</td>
                                <td>
                                  {moment(itm.startTime, "HH:mm:ss").format(
                                    "hh:mm A"
                                  )}
                                </td>
                                <td>
                                  {moment(itm.endTime, "HH:mm:ss").format(
                                    "hh:mm A"
                                  )}
                                </td>
                                <td>{itm.initialTemperature}</td>
                                <td>{itm.finalTemperature}</td>
                                <td>{itm.preCoolingMethod}</td>
                                {canEdit === "block" && (
                                <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      sId(serviceId);
                                      props.update(itm);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>)}
                                {canDelete === "block" && (
                                <td>
                                  <button
                                    type="button"
                                    //  onClick={(e) => handleDelete(e, itm)}
                                    className="btn"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>)}
                                {canView === "block" && (
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>)}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal
        isOpen={isModalOpen}
        style={customModalStyles}
        appElement={document.getElementById("root")}
      >
        {selectedData && (
          <div>
            <h4 className="card-title">PreCooling Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                PreCooling No: {selectedData.preCoolingNo}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Date: {selectedData.preCoolingDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Assign Supervisor: {selectedData.employeeName}
              </p>
              <p className="col-md-6">
                Palletization No: {selectedData.palletizationNo}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Pre-Cooling Method: {selectedData.preCoolingMethod}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Start Time :{" "}
                {moment(selectedData.startTime, "HH:mm:ss").format("hh:mm A")}
              </p>

              <p className="col-md-6">
                End Time:{" "}
                {moment(selectedData.endTime, "HH:mm:ss").format("hh:mm A")}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Initial Temperature(°C): {selectedData.initialTemperature}
              </p>
              <p className="col-md-6">
                Final Temperature (°C) : {selectedData.finalTemperature}
              </p>
            </div>
            <br />
            <h5 className="card-title">Pallet Details</h5>
            <table className="table table-bordered table-sm">
              <thead>
                <tr className="">
                  <th>Pallet No</th>
                  <th>Item Quality)</th>
                  <th>Product Cost</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productData &&
                  selectedData.productData.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.palletNo}</td>
                        <td>{itm.itemQuantity}</td>
                        <td>{itm.productCost}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default PreCoolingListview;
